var map = {
	"./icon-arrow.svg": 51089,
	"./icon-close.svg": 50829,
	"./icon-copy.svg": 54171,
	"./icon-edit.svg": 47766,
	"./icon-getgems.svg": 45472,
	"./icon-lfg.svg": 54012,
	"./icon-lock.svg": 20111,
	"./icon-log.svg": 90943,
	"./icon-ok.svg": 35686,
	"./icon-ok1.svg": 43440,
	"./icon-ok2.svg": 71008,
	"./icon-quest.svg": 62711,
	"./icon-refresh.svg": 82037,
	"./icon-refresh2.svg": 44627,
	"./icon-rightarrow.svg": 90883,
	"./icon-share.svg": 71820,
	"./icon-sigh.svg": 34383,
	"./icon-spin.svg": 4173,
	"./icon-telegram.svg": 45810,
	"./icon-user.svg": 8639
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42007;